import React from "react";
import { Route, Switch } from "react-router-dom";

import { CarwebGetVehicleByVRMForm } from "./carweb-get-vehicle-by-vrm";

export default () => {
    return {
        routes: [
            {
                path: "/test-harnesses",
                render: ({ match }) => (
                    <Switch>
                        <Route
                            path={`${match.url}/carweb-get-vehicle-by-vrm`}
                            exact
                            component={CarwebGetVehicleByVRMForm}
                        />
                    </Switch>
                ),
            },
        ],
    };
};
